import Vue from "vue"
import VueRouter from "vue-router"
import store from "../store"
import system from "./system"
import order from "./order"
import user from "./user"
import contents from "./contents"
import teacher from "./teacher"
import myLive from "./myLive"
import carouselPicture from "./carouselPicture"
import courseManage from "./courseManage"
import liveManage from "./liveManage"
import myCourse from "./myCourse"
import customerService from "./customerService"
import opinion from "./opinion"
import activityManage from "./activityManage"
import pointManage from "./pointManage"
import studyTour from "./studyTour"
import upload from "./upload"
import agreement from "./agreement"
import question from "./question"
import logs from "./logs"
import dynamic from "./dynamic"

Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    component: () => import("../views/Main"),
    meta: { title: "管理后台" },
    children: [
      ...system,
      ...user,
      ...contents,
      ...order,
      ...teacher,
      ...myLive,
      ...carouselPicture,
      ...courseManage,
      ...liveManage,
      ...myCourse,
      ...customerService,
      ...opinion,
      ...activityManage,
      ...pointManage,
      ...studyTour,
      ...upload,
      ...agreement,
      ...question,
      ...logs,
      ...dynamic,
      {
        path: "/personals",
        name: "personals",
        component: () => import("../views/Personals"),
        meta: { title: "个人信息" },
      },
    ],
  },
  {
    path: "/login",
    name: "/login",
    component: () => import("../views/Login"),
    meta: { title: "管理后台-登录" },
  },
  {
    path: "/404",
    name: "404",
    meta: { title: "服务器拒绝访问或页面不存在" },
    component: () => import("../views/404"),
  },
]

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
})

const originaPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originaPush.call(this, location).catch(err => err)
}

router.beforeEach((to, form, next) => {
  const token = store.state.token
  if (to.path == "/register" || to.path == "/forgotPassword") {
    next()
  } else if (!token && to.path !== "/login") {
    store.dispatch("logout")
    next("/login")
  } else if (token && to.path == "/login") {
    store.dispatch("logout")
    localStorage.clear()
    next()
  } else {
    next()
  }
})

router.afterEach(to => {
  if (to.meta.title) document.title = to.meta.title
})

export default router
